<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="所属团队" prop="teamId" v-if="roleId==2">
						<el-select v-model="queryParams.teamId" style="width: 100%;" placeholder="请选择团队">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属机构" v-if="institutionId==1">
						<el-select v-model="queryParams.institutionId" filterable placeholder="请选择机构">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备状态">
						<el-select v-model="queryParams.onlineStatus" placeholder="请选择设备状态">
							<el-option key="-1" label="全部" value=""></el-option>
							<el-option key="1" label="在线" :value="1"></el-option>
							<el-option key="0" label="离线" :value="0"></el-option>
							<el-option key="2" label="报警" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备标签">
						<el-select v-model="queryParams.tags" filterable placeholder="请选择设备标签">
							<el-option label="全部" value=""></el-option>
							<el-option :key="tag" :label="tag" :value="tag" v-for="tag in allTags"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备名称">
						<el-input v-model="queryParams.title" placeholder="请输入设备名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleReset">重置</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
						<el-button type="danger" size="small" @click="batchDelete" v-has="'btn_del'">批量删除</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column fixed type="selection" width="55"></el-table-column>
					<el-table-column prop="tags" label="所属标签">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
								{{tag}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="设备名称">
						<template slot-scope="scope" >
							<el-button type="text" @click="handleDetail(scope.row)">{{scope.row.title}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="templateTitle" label="设备模版"></el-table-column>
					<el-table-column prop="onlineStatus" label="设备状态" width="80" align="center">
						<template slot-scope="scope" >
							<span class="icon iconfont icon-zaixian" style="color:#409EFF" v-if="scope.row.onlineStatus==1"></span>
							<span class="icon iconfont icon-a-cloud-slash-fill-sharp-10" style="color:#D7440E" v-else></span>
						</template>
					</el-table-column>
					<el-table-column prop="onlineStatus" label="水滴变量" width="80" align="center">
						<template slot-scope="scope">
							<span class="icon iconfont icon-shuidi" style="color:#D7440E;font-size: 18px;" v-if="scope.row.isDrip==2||scope.row.onlineStatus!=1"></span>
							<span class="icon iconfont icon-shuidi" style="color:#909399;font-size: 18px;" v-else-if="scope.row.isDrip==1"></span>
							<span class="icon iconfont icon-shuidi" style="color:#409EFF;font-size: 18px;" v-else-if="scope.row.isDrip==3"></span>
						</template>
					</el-table-column>
					<el-table-column prop="onlineStatus" label="报警" width="80" align="center">
						<template slot-scope="scope">
							<span class="icon iconfont icon-baojing1" style="color:#D7440E;font-size: 18px;" v-if="scope.row.isAlarm==3||scope.row.onlineStatus!=1"></span>
							<span class="icon iconfont icon-baojing1" style="color:#909399;font-size: 18px;" v-else></span>
						</template>
					</el-table-column>
					<el-table-column prop="institutionName" label="所属机构" width="80px" align="center">
						<template slot-scope="scope">
							<el-image style="width: 50px; height: 50px" :src="scope.row.logo" fit="fit"></el-image>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看</el-button>
							<el-button size="mini" type="primary" @click="handleLog(scope.row)">上下线</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>基本信息</span>
					</div>
					<div style="padding-right: 20px;">
						<el-row>
							<el-col :span="12">
								<el-form-item label="设备编号" prop="code"><el-input type="text" v-model="addOrUpdateForm.code" placeholder="请输入设备编号"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="设备名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title" placeholder="请输入设备名称"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="关联标签" prop="tags">
									<el-input type="text" v-model="addOrUpdateForm.tag" placeholder="请输入设备标签,按enter键自动创建" @keyup.enter.native="handleEnter"></el-input>
									<el-tag v-for="(tag,index) in tags" :key="index" closable type="" @close="handleRemoveTag(tag)">
										{{tag}}
									</el-tag>
								</el-form-item>

							</el-col>
							<el-col :span="12">
								<el-form-item label="设备定位" prop="cityCode">
									<el-cascader ref="cascader" @change="handleChangeCity"  :options="options" style="width: 299px;"  v-model="addOrUpdateForm.selectedOptions"></el-cascader>
								</el-form-item>
							</el-col>
						</el-row>
						<el-col :span="12">
							<el-form-item label="所属机构" prop="institutionId">
								<el-select v-model="addOrUpdateForm.institutionId" filterable placeholder="请选择机构" style="width: 299px;">
									<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="设备描述" prop="description">
								<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
							</el-form-item>
						</el-col>
					</div>
				</el-card>
				<el-card class="box-card" style="margin-top: 10px;">
					<div slot="header" class="clearfix">
						<span>数据设置</span>
					</div>
					<div style="padding-right: 20px;">
						<el-form-item label="关联模版" prop="templateId">
							<el-select v-model="addOrUpdateForm.templateId" filterable remote reserve-keyword placeholder="请选择模版" :remote-method="queryTemplateList"
								:loading="templateLoading" @focus="templateSelectFocus" :clearable="true">
								<el-option v-for="item in templateList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
				</el-card>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog v-loading="logLoading" title="设备上下线" :visible.sync="dialogLogVisible" width="900px" :close-on-click-modal="false"   @close="handleLogCloase">
			<el-row>
				<el-col :span="24" class="handleLogQuery">
					<el-form :inline="true" :model="queryLogParams" class="form" size="small" label-width="80px">
						<el-form-item label="设备名称" label-width="80px">
							<el-input v-model="queryLogParams.title" disabled placeholder="请输入设备名称"></el-input>
						</el-form-item>
						<el-form-item label="日期范围" prop="createDates">
							<el-date-picker v-model="queryLogParams.createDates" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm" :default-time="['00:00:00', '00:00:00']">
							</el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" size="small" @click="queryLog">查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table :data="logs" stripe border  tooltip-effect="dark">
						<el-table-column type="index" label="序号"></el-table-column>
						<el-table-column prop="name" label="状态">
							<template slot-scope="scope" >
								{{scope.row.onlineStatus | formatOnlineStatus}}
							</template>
						</el-table-column>
						<el-table-column prop="message" label="下线原因"></el-table-column>
						<el-table-column prop="updateTime" label="时间"></el-table-column>
					</el-table>
					<!-- 分页 -->
					<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryLogParams.currentPage"
						:page-size="queryLogParams.pageSize" :total="queryLogParams.totalNum" @size-change="pageLogSizeChange" @current-change="pageLogCurrentChange"></el-pagination>
				</el-col>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogLogVisible = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import common from '@/common/common.js';



	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'devices',
				name: '设备',
				institutionList: [],
				options: [],
				allTags: [],
				tags: [],
				queryTemplateParams: {
					currentPage: 1,
					pageSize: 999,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				dialogTemplateVisible: false,
				templateList: [],
				dialogLogVisible:false,
				logs:[],
				logLoading:true,
				queryLogParams: {
					currentPage: 1,
					pageSize: 10,
					createDates:[],
					totalNum:0
				},
				pickerOptions: {
					disabledDate(time) {
						const now = new Date();
						const thirtyDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000); // 30天前
						return time.getTime() < thirtyDaysAgo.getTime();
					}
				},
				templateLoading: false,
				institutionId: null,
				roleId:null,
				teamList:[],
				rules: {
					code: [{
							required: true,
							message: '请输入设备编号',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度要求20',
							trigger: 'blur'
						},{
							min: 20,
							message: '长度要求20',
							trigger: 'blur'
						}
					],
					title: [{
							required: true,
							message: '请输入设备名称',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
					templateId: [{
						required: true,
						message: '请选择模版',
						trigger: 'blur'
					}],
					cityCode: [{
						required: true,
						message: '请选择定位信息',
						trigger: 'change'
					}],
					institutionId: [{
						required: true,
						message: '请选择所属机构',
						trigger: 'change'
					}],
				}
			};
		},
		filters: {
			formatOnlineStatus(onlineStatus) {
				if (onlineStatus == 0) {
					return '下线'
				} else if (onlineStatus == 1) {
					return '上线'
				}
			}
		},
		methods: {
			queryAreaList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'area/queryTree',
					data: {},
				}).then((res) =>{
					this.options=res.data.data
				})
			},
			handleDetail(row) {
				common.routerPush(this, '/front/device/deviceDetail', {
					deviceId: row.id
				})
			},
			handleLog(row) {
				this.logLoading = true;
				this.queryLogParams.deviceId=row.id;
				this.queryLogParams.title=row.title;
				this.queryLogParams.createDates=[];
				this.dialogLogVisible=true;
				this.queryLogParams.currentPage =1;
				this.logs=[]
				this.queryLog();
			},
			queryLog(){
				this.$http({
					method: 'POST',
					url: 'mngr/device/online/log/query',
					data: this.queryLogParams,
				}).then((res)=> {
					this.logs=res.data.data;
					this.queryLogParams.totalNum = res.data.page.totalNum;
					this.queryLogParams.totalPage=res.data.page.totalPage;
				})
			},
			handleLogCloase(){
				this.logs=[]
			},
			handleReset() {
				this.queryParams.institutionId = null
				this.queryParams.onlineStatus = null
				this.queryParams.tags = null
				this.queryParams.title = null
			},
			queryInstitutionList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'institution/query',
					data: {
						currentPage: 1,
						pageSize: 100
					},
				}).then(function(res) {
					that.institutionList = res.data.data;
				})
			},
			showTemplate() {
				this.queryTemplateParams.name = ""
				this.queryTemplateParams.currentPage = 1
				this.dialogTemplateVisible = true;
				this.queryTemplateList()

			},
			handleChooseTheme(row) {
				this.addOrUpdateForm.templateId = row.id
				this.addOrUpdateForm.templateTitle = row.title
				this.dialogTemplateVisible = false
			},
			templateSelectFocus() {
				this.queryTemplateList()
			},
			queryTemplateList(query) {
				let that = this;
				this.templateLoading = true;
				this.queryTemplateParams.title = query;
				this.$http({
					method: 'POST',
					url: 'template/query',
					data: this.queryTemplateParams,
				}).then(function(res) {
					that.templateList = res.data.data;
					that.templateLoading = false
				})
			},
			templatePageCurrentChange(val) {
				// 分页
				this.queryTemplateParams.currentPage = val;
				this.queryTemplateList();
			},
			templatePageSizeChange(val) {
				//调整每页显示条数
				this.queryTemplateParams.pageSize = val;
				this.queryTemplateParams.currentPage = 1;
				this.queryTemplateList();
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			handleChangeCity(node) {
				this.addOrUpdateForm.provinceCode = this.addOrUpdateForm.selectedOptions[0]
				this.addOrUpdateForm.cityCode = this.addOrUpdateForm.selectedOptions[1]
			},
			beforeUpdate() {
				this.addOrUpdateForm.tags = JSON.stringify(this.tags)
			},
			handleEnter() {
				if (this.addOrUpdateForm.tag) {
					if (this.tags.indexOf(this.addOrUpdateForm.tag) == -1) {
						this.tags.push(this.addOrUpdateForm.tag)
						this.addOrUpdateForm.tag = ""
					} else {
						this.$message({
							message: '标签' + this.addOrUpdateForm.tag + '已存在',
							type: 'warning'
						});
					}
				}
			},
			handleRemoveTag(tag) {
				this.tags.splice(this.tags.indexOf(tag), 1);
			},
			beforeEdit(isEdit) {
				this.tags = []
				if (this.addOrUpdateForm.cityCode) {
					this.addOrUpdateForm.selectedOptions = [this.addOrUpdateForm.provinceCode, this.addOrUpdateForm.cityCode]
				}
				this.templateList = [{
					title: this.addOrUpdateForm.templateTitle,
					id: this.addOrUpdateForm.templateId
				}]
				if (isEdit && this.addOrUpdateForm.tags) {
					this.tags = JSON.parse(this.addOrUpdateForm.tags)
				}
			},
			queryTags() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'devices/queryTags',
					data: {},
				}).then(function(res) {
					that.allTags = res.data.data;
				})
			},
			queryTeamList() {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then(function(res) {
					that.teamList = res.data.data;
				})
			},
			pageLogCurrentChange(val) {
				// 分页
				this.queryLogParams.currentPage = val;
				this.queryLog();
			},
			pageLogSizeChange(val) {
				//调整每页显示条数
				this.queryLogParams.pageSize = val;
				this.queryLogParams.currentPage = 1;
				this.queryLog();
			},
		},
		mounted: function() {
			this.queryTags();
			this.institutionId = sessionStorage.getItem('_institutionId');
			if (this.hasAuth('btn_add')) {
				this.queryInstitutionList()
				this.queryAreaList();
			}
			this.roleId = sessionStorage.getItem('_roleId');
			if(this.roleId==2){
				this.queryTeamList()
			}
			if (this.$route.query.teamId) {
				this.queryParams.teamId=this.$route.query.teamId;
			}
			//this.queryTags();
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.el-tag {
		margin: 0px 8px 5px 0px;
		padding: 0 5px;
	}

	/deep/ .el-card__header {
		border-bottom: 0px;
	}

	/deep/ .el-card__body {
		padding: 0px;
	}
	
	.handleLogQuery{
		.form {
			margin: 0px;
		}
		/deep/ .el-date-editor.el-input__inner,
		.handleQuery .el-date-editor.el-input {
			width: 380px !important;
			;
		}
		
		.el-date-editor {
			width: 400px;
		
			input {
				width: 148px !important;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/devices.vue